import React, { Component } from 'react';
import DraggableAreaControl from './DraggableArea'
import { Popover, Input, Modal, Icon, Button, Checkbox, Radio, Transfer, Select, Tag } from 'antd';
import Row from '../basic/row';
import Col from '../basic/col';
import Input2 from '../basic/input';
import InputSearch from '../common/InputSearch';
import SvgIcon from 'SvgIcon';
import { proxy } from '../../helpers/util';
const RadioGroup = Radio.Group;
let leftDisabledKeys = [];
class DimensionSetting extends Component {
  constructor(props) {
    super(props);
    let checkedData = [[]];
    checkedData.push([]);
    const { viewModel, cStyle } = props;
    const { billNo } = viewModel.getParams();
    this.initDimensionListValue(billNo);
    this.state = {
      cStyle: cStyle && JSON.parse(cStyle),
      selectedNum: 0,
      checkedItem: null,
      selectedItems: [],
      dimensionItems: [],
      billnum: billNo,
      keyWord: "",
      bShowCard: false,
      bShowList: false,
      textMouseEnterId: -1,
      currentName: "",
      currentId: '',
      dimensionList: [],
      editDimension: {
        bEdit: false,
        name: "",
        isDefault: false,
      },
      uncheckedData: [],
      checkedData: checkedData,
      rightIndex: 0,
      isEnterInput: false,
      editId: '',
    }
    this.setModel(viewModel);
  }
  setModel(viewModel) {
    this.model = new cb.models.SimpleModel({ needClear: false });
    viewModel.setCache("dimensionModel", this.model);
    this.model.on("changeDimension", (obj) => this.modelChange(obj));
  }
  setModelValue(value) {
    this.model.setValue(value);
  }
  setModelCache(dimensionList) {
    this.model.setCache("dimensionList", dimensionList);
  }
  modelChange(obj) {
    this.chooseDimension(obj.id, "");
  }
  componentDidMount() {
  }

  changeTags(tags, index) {
    let { checkedData } = this.state;
    checkedData[index] = tags;
    this.checkmock(checkedData)
  }

  uncheckedSort(uncheckedData) {
    return uncheckedData.sort((a, b) => a.id - b.id)
  }

  changeunchecked(tags) {
    tags[tags.length - 1].checked = false
    this.setState({ uncheckedData: this.uncheckedSort(tags) })
  }

  handleClickDelete(tag, index) {
    leftDisabledKeys = leftDisabledKeys.filter(t => t !== tag.fieldname)
    let { checkedData, dimensionItems, selectedItems } = this.state;
    selectedItems = selectedItems.filter(t => t.fieldname !== tag.fieldname)
    dimensionItems.forEach(function (ele, index) {
      if (ele.fieldname == tag.fieldname) {
        ele.bSelected = false;
      }
    })
    index = this.findIndex(checkedData, index)
    const Tags = checkedData[index].filter(t => tag.id !== t.id);
    checkedData[index] = Tags;
    this.setState({ selectedItems: selectedItems, dimensionItems: dimensionItems, checkedData: checkedData })
  }

  findIndex(checkedData, index) {
    for (let i = index; i < checkedData.length; i++) {
      if (!checkedData[i].length) {
        index++
      } else {
        break;
      }
    }
    return index
  }

  handelClick(rightIndex) {
    this.setState({ rightIndex })
  }

  handleTagTriggerClick(_index, index, e) {// _index: 大排序 index:所在组排序
    let { checkedData } = this.state;
    checkedData = checkedData.map((value, _I) => {
      return value.map((val, _i) => {
        if (_I !== _index || _i !== index) {
          val.checked = false;
        } else {
          val.checked = true
        }
        return val
      })
    })
    this.setState({ checkedData })
  }

  checkmock(checkedData) {
    checkedData = checkedData.filter(t => t.length)
    checkedData.push([])
    this.setState({ checkedData })
  }

  checkedUncheckedData(tag, index, e) {
    let { uncheckedData } = this.state;
    uncheckedData[index].checked = e.target.checked
    this.setState({ uncheckedData })
  }

  onRightButtonClick = () => {
    let { checkedItem, selectedItems, checkedData, rightIndex } = this.state;
    if (checkedItem) {
      selectedItems.push(checkedItem);
      let _checkedData = [];
      _checkedData.push(checkedItem)
      _checkedData = _checkedData.map(v => {
        v.checked = false
        return v
      })
      checkedData[rightIndex] = checkedData[rightIndex].concat(_checkedData)
    }
    this.setState({ selectedNum: 0, checkedItem: null, selectedItems: selectedItems, checkedData })
    this.checkmock(checkedData)
  }

  async initDimensionListValue(billNo) {
    const config = {
      url: 'report/getDimensions',
      method: 'GET',
      params: {
        billnum: billNo,
      }
    }
    const json = await proxy(config);
    if (json.code !== 200) {
      cb.utils.alert('获取维度列表失败！' + json.message, 'error');
      return;
    }
    let defaultItem = json.data.filter(ele => ele.isDefault == true);
    let currentId = defaultItem.length !== 0 ? defaultItem[0].id : '';
    let currentName = defaultItem.length !== 0 ? defaultItem[0].name : '';
    this.setState({ dimensionList: json.data, currentId, currentName })
    this.setModelValue(currentId);
    this.setModelCache(json.data);
    this.props.viewModel.execute('dimensionChanged', { dimensionId: currentId });
    this.props.viewModel.on('refreshEChartConfig', (params) => {
      let tmpId = -1;
      let tmpName = "";
      let dimensionList = this.state.dimensionList;
      let presetItem = params.dimensionId && dimensionList.filter(ele => ele.id == params.dimensionId)
      if (presetItem && presetItem.length > 0) {
        tmpId = params.dimensionId;
        tmpName = presetItem[0].name;
      }
      else {
        dimensionList && dimensionList.forEach(function (ele, index) {
          if (ele.isDefault == true || index == 0) {
            tmpId = ele.id;
            tmpName = ele.name;
          }
        });
      }
      if (tmpId > 0) {
        this.setModelValue(tmpId);
        if (this.state.currentId != tmpId) {
          this.setState({ currentId: tmpId, currentName: tmpName })
        }
        this.props.viewModel.execute('dimensionChanged', { dimensionId: tmpId })
      }
    }
    )
  }
  async refreshDimensionListValue(billNo) {
    const config = {
      url: 'report/getDimensions',
      method: 'GET',
      params: {
        billnum: billNo,
      }
    }
    const json = await proxy(config);
    if (json.code !== 200) {
      cb.utils.alert('获取维度列表失败！' + json.message, 'error');
      return;
    }
    this.setState({ dimensionList: json.data, })
    this.setModelCache(json.data);
  }

  async getDimensionItems(billNo) {
    const config = {
      url: 'report/getGroupItems',
      method: 'GET',
      params: {
        billnum: billNo,
      }
    }
    const json = await proxy(config);
    if (json.code !== 200) {
      cb.utils.alert('获取数据失败！' + json.message, 'error');
      return;
    }
    json.data.unselected.forEach(function (ele, index) {
      ele.id = ele.fieldname
    }
    )
    this.setState({ dimensionItems: json.data.unselected })
  }

  async onOk(params) {
    const config = {
      url: 'report/saveDimensionSchema',
      method: 'POST',
      params: params,
    }
    const json = await proxy(config);
    if (json.code !== 200) {
      cb.utils.alert('保存失败！' + json.message, 'error');
      return;
    }
    cb.utils.alert("保存成功！", 'success');
    leftDisabledKeys = [];
    this.refreshDimensionListValue(this.state.billnum);
    let { editDimension, editId, currentId } = this.state;
    if (editId == currentId) {
      this.props.viewModel.execute('dimensionChanged', { dimensionId: editId })
    }
    editDimension.name = "";
    editDimension.isDefault = false;
    editDimension.bEdit = false;
    this.setState({ rightIndex: 0, bShowCard: false, selectedNum: 0, checkedItem: null, selectedItems: [], keyWord: "", editDimension: editDimension, checkedData: [[], []], editId: '' })
  }

  ShowList = () => {
    // this.initDimensionListValue(this.state.billnum);
    document.body.addEventListener('click', this.handleBodyClick);
    this.setState({ bShowList: !this.state.bShowList })
  }

  handleCancel = (e) => {
    leftDisabledKeys = []
    let { editDimension } = this.state;
    editDimension.name = "";
    editDimension.isDefault = false;
    editDimension.bEdit = false;
    let checkedData = [[]];
    checkedData.push([]);
    this.setState({ bShowCard: false, selectedNum: 0, checkedItem: null, selectedItems: [], keyWord: "", editDimension: editDimension, checkedData, editId: '', rightIndex: 0 })
  }

  handleOk = (e) => {
    let { billnum, editDimension, selectedItems, checkedData, editId } = this.state;
    if (editDimension.name == "") {
      cb.utils.alert("名称不可为空。");
      return
    }
    let checked_Data = checkedData.filter(t => t.length);
    if (checked_Data.length == 0) {
      cb.utils.alert("请添加数据项到已选区域!")
      return
    }
    if (checked_Data.length > 3) {
      cb.utils.alert("最多只支持三级维度导航！")
      return
    }
    let selected = [];
    checked_Data.forEach(function (ele, index) {
      ele.forEach(function (ele) {
        selected.push({ fieldname: ele.fieldname, caption: ele.caption, groupType: 0, level: index + 1 })
      })
    })
    let params = { billnum: billnum, name: editDimension.name, isDefault: editDimension.isDefault, selected: selected, type: 2, isPc: true, id: editId ? editId : null }
    this.onOk(params)
  }

  getDimensionCardRender() {
    let editDimension = this.state.editDimension;
    let bEdit = editDimension.bEdit;
    let content;
    if (this.state.bShowCard == true) {
      let card;
      card = this.getInnerRender();
      content =
        <Modal className='crossGroupingModal addDimension'
          title={bEdit ? "编辑" : "新增维度导航方案"}
          onOk={(e) => this.handleOk(e)}
          onCancel={(e) => this.handleCancel(e)}
          visible={true}
        >
          {card}
        </Modal>;
    }
    return content;
  }

  onTextMouseEnter(bEnter) {
    this.setState({ isEnterInput: bEnter })
  }

  onMouseEnter(bEnter, e, id) {
    let dimensionList = this.state.dimensionList;
    if (dimensionList && dimensionList.length > 0) {
      dimensionList.forEach(function (ele, index) {
        if (ele.id == id)
          ele.isMouseEnter = bEnter;
      });
    }
    this.setState({ dimensionList: dimensionList })
  }

  editDimension_SetValue = (fieldName, fieldValue) => {
    const { editDimension } = this.state;
    editDimension[fieldName] = fieldValue;
    this.setState({ editDimension: editDimension })
  }

  selectItems = (fieldname, bSelected) => {
    let { dimensionItems, selectedNum, checkedItem } = this.state;
    if (bSelected == true) {
      if (selectedNum == 1) {
        cb.utils.alert("每次只能选择一个数据项！", 'error');
        return
      }
      dimensionItems.forEach(function (ele, index) {
        if (ele.fieldname == fieldname) {
          ele.bSelected = true;
          checkedItem = ele;
        }
      })
      this.setState({ dimensionItems: dimensionItems, selectedNum: 1, checkedItem: checkedItem })
      return
    }
    dimensionItems.forEach(function (ele, index) {
      if (ele.fieldname == fieldname) {
        // delete ele.bSelected
        ele.bSelected = false;
      }
    })
    this.setState({ dimensionItems: dimensionItems, selectedNum: 0, checkedItem: null })
  }



  SetKeyWord = (fieldValue) => {
    this.setState({ keyWord: fieldValue })
  }

  handelClick(rightIndex) {
    this.setState({ rightIndex })
  }

  getInnerRender() {
    let self = this;
    let { editDimension, dimensionItems, selectedItems, checkedData, rightIndex } = this.state;

    checkedData = checkedData.filter(v => v.length);
    checkedData.push([]);

    let leftContentRender = [], rightContentRender = [];
    selectedItems.forEach(function (ele, index) {
      leftDisabledKeys.push(ele.fieldname);
      rightContentRender.push(
        <Tag>
          {ele.caption}
        </Tag>
      )
    }
    )
    dimensionItems.forEach(function (ele, index) {
      if (ele.caption.indexOf(self.state.keyWord) > -1) {
        let bChecked = ele.bSelected ? true : false;
        let bDisabled = leftDisabledKeys.indexOf(ele.fieldname) > -1 ? true : false;
        leftContentRender.push(
          <Row>
            <Checkbox
              checked={bChecked}
              disabled={bDisabled}
              onChange={(e) => self.selectItems(ele.fieldname, e.target.checked)}
            >
              {ele.caption}
            </Checkbox>
          </Row>
        )
      }
    })

    return <div>
      <br />
      <Row colCount={12} className="crosstype">
        <Col span={1} className="crosstypeName crosstypeline"><i className="anticon anticon-star nametitlemarginstar"></i>名称</Col>
        <Col span={1} />
        <Col span={4} className="crosstypeNameList crossinput"><Input defaultValue={editDimension.name} onChange={(e) => this.editDimension_SetValue("name", e.target.value)} /> </Col>
        <Col span={1} />
        <Col span={5} className="crosscheckbox"><Checkbox checked={editDimension.isDefault} onChange={(e) => this.editDimension_SetValue("isDefault", e.target.checked)}>设为默认</Checkbox></Col>
      </Row>
      <br />
      <Row colCount={12}>
        <Col span={5} className="crossadddata">
          <div>
            <Row className="crossaddnamemargin">添加数据项</Row>
            <div className="crossselectborder">
              <InputSearch placeholder="请输入关键字"
                value={this.state.keyWord}
                onChange={(value) => this.SetKeyWord(value)}
                onDelete={() => this.SetKeyWord("")}
              />
              <Row className="crossadddatalist">{leftContentRender}</Row>
            </div>
          </div>
        </Col>
        <Col span={2} className="crossbtncount dimension">
          <Button className={"icon-right-enabled"} onClick={this.onRightButtonClick}></Button>
        </Col>
        <Col span={5} className="selecteddata">
          <div>
            <Row className="crossaddnamemargin">已选数据项<span style={{ color: 'red' }}>（最多支持三级导航）</span></Row>
            <div className="groupCondition-SelectedItem">
              <div className="crossArea">

                <div className='fr crossArea-list'>
                  {checkedData.map((value, index) => {
                    return <div key={'crossArea-list' + index} onClick={() => this.handelClick(index)} className='crossArea-list-content' style={{ left: (63 + index * 27) + 'px', top: (index * 46) + 'px' }}>
                      {checkedData.length - 1 !== index ? (index == 0 ? <Button size={'small'}><Icon type='tianjiashuliang' /></Button> : <Button size={'small'}><Icon type='jianshaoshuliang' /></Button>) : null}
                      <DraggableAreaControl dragChecked={rightIndex === index}
                        handleTagTriggerClick={(_index, index, e) => { this.handleTagTriggerClick(_index, index, e) }}
                        clickDelete={(tag, index) => { this.handleClickDelete(tag, index) }} Tags={value} index={index}
                        changeTags={(tag, index) => this.changeTags(tag, index)} selectedItems={selectedItems}
                      />
                    </div>
                  })}
                </div>

              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  }

  async setDefaultItem(id, name) {
    const { billnum } = this.state;
    const config = {
      url: 'report/saveDimensionSchema',
      method: 'POST',
      params: {
        billnum,
        id,
        isDefault: true,
        name,
      }
    }
    const json = await proxy(config);
    if (json.code !== 200) {
      cb.utils.alert('操作失败！' + json.message, 'error');
      return;
    }
    this.refreshDimensionListValue(this.state.billnum);
  }

  async editDimensionInfo(id) {
    this.setState({ editId: id, rightIndex: 0 })
    this.getDimensionItems(this.state.billnum);
    const config = {
      url: '/report/getDimensionSetting',
      method: 'GET',
      params: {
        billnum: this.state.billnum,
        dimensionId: id,
      }
    }
    const json = await proxy(config);
    if (json.code !== 200) {
      cb.utils.alert('获取数据失败！' + json.message, 'error');
      return
    }

    let { editDimension, dimensionItems, selectedItems } = this.state;
    editDimension.bEdit = true;
    editDimension.name = json.data.name;
    editDimension.isDefault = json.data.isDefault;
    json.data.selected.forEach(function (ele, index) {
      leftDisabledKeys.push(ele.fieldname)
    })
    if (dimensionItems) {
      dimensionItems.forEach(function (ele, index) {
        if (leftDisabledKeys.indexOf(ele.fieldname) > -1) {
          ele.bSelected = true
          selectedItems.push(ele)
        }
      })
    }
    let selectedData = [];
    if (json.data.selected) {
      let level_1 = json.data.selected.filter(t => t.level == 1)
      let level_2 = json.data.selected.filter(t => t.level == 2)
      let level_3 = json.data.selected.filter(t => t.level == 3)
      if (level_1.length !== 0) {
        level_1.forEach(function (ele) {
          ele.id = ele.fieldname
        })
        selectedData.push(level_1)
      }
      if (level_2.length !== 0) {
        level_2.forEach(function (ele) {
          ele.id = ele.fieldname
        })
        selectedData.push(level_2)
      }
      if (level_3.length !== 0) {
        level_3.forEach(function (ele) {
          ele.id = ele.fieldname
        })
        selectedData.push(level_3)
      }
    }
    selectedData = selectedData.filter(t => t.length !== 0);
    selectedData.push([]);
    this.setState({ bShowCard: true, bShowList: false, editDimension: editDimension, checkedData: selectedData, dimensionItems: dimensionItems, selectedItems: selectedItems })

  }

  async deleteDimension(id, name) {
    const config = {
      url: '/report/deleteGroupSchema',
      method: 'GET',
      params: {
        groupSchemaId: id
      }
    }
    const json = await proxy(config);
    if (json.code !== 200) {
      cb.utils.alert('操作失败！' + json.message, 'error');
      return
    }
    if (name == this.state.currentName) {
      this.setState({ currentName: "", currentId: '' })
    }
    this.refreshDimensionListValue(this.state.billnum);

  }

  getDimensionListRender() {
    let canEdit = true;
    if (this.state.cStyle && this.state.cStyle.disableUserSetting == true) {
      canEdit = false;
    }
    let dimensionList = this.state.dimensionList;
    let currentId = this.state.currentId;
    let renderList = [];
    let bAuthAdd = this.state.bAuthAdd;
    let bAuthEdit = this.state.bAuthEdit;
    let bAuthDel = this.state.bAuthDel;
    if (this.state.bIgnoreAuth === true) {
      bAuthAdd = true;
      bAuthEdit = true;
      bAuthDel = true;
    }

    if (dimensionList && dimensionList.length > 0) {
      dimensionList.forEach(function (element, index) {
        let item;
        let isChecked = element.id == currentId ? true : false;
        let itemChecked = isChecked ? <span className="groupCondition-Checked"><i className="anticon icon-xuanzhong1" checked={isChecked}></i>  </span > : <span className="groupCondition-Checked">  </span >;
        let isDefault = element.isDefault ? element.isDefault : false;
        let itemDefault = isDefault ? <span className="groupCondition-Default"> <span className="crossdefault-btn">默认</span>  </span> : <span className="groupCondition-Default">  </span>;
        let isMouseEnter = element.isMouseEnter ? element.isMouseEnter : false;
        let itemEnter = isMouseEnter ? (canEdit ?
          <span className="groupCondition-MouseEnter">
            {isDefault ? null : <span
              onClick={() => this.setDefaultItem(element.id, element.name)}>设为默认</span>
            }
            <span
              onClick={() => this.editDimensionInfo(element.id)}
            >设置</span>
            <span
              onClick={() => this.deleteDimension(element.id, element.name)}
            >删除</span>

          </span> : <span className="groupCondition-MouseEnter"> </span  >) : <span className="groupCondition-MouseEnter"> </span  >;

        item = (
          <Row style={{ minHeight: "25px" }}
            onMouseEnter={(e) => this.onMouseEnter(true, e, element.id)}
            onMouseLeave={(e) => this.onMouseEnter(false, e, element.id)}
          >
            {itemChecked}
            <span style={{ cursor: "pointer" }} onClick={() => this.chooseDimension(element.id, element.name)}> {element.name}</span>
            {itemDefault}
            {itemEnter}
          </Row>
        )
        renderList.push(item);
      }, this);
    }
    let addItem = canEdit ? <div className="group-add-grouping">
      <div
        onClick={() => this.addDimensionInfo()}><SvgIcon type="plus" />新增维度导航方案
    </div>
    </div> : null;

    return (
      <div className={"group-add-grouping-count " + (canEdit == false ? "group-add-grouping-count-noauth" : "")}>
        <div style={{ overflow: "auto", maxHeight: "258px", paddingBottom: "2px" }} >{renderList}</div>
        {addItem}
      </div>
    );
  }

  addDimensionInfo() {
    this.getDimensionItems(this.state.billnum);
    this.setState({ bShowCard: true, bShowList: false })
  }

  chooseDimension(id, name) {
    if (id && name == "") {
      let tmp = _.find(this.state.dimensionList, function (o) { return o.id == id });
      name = tmp ? tmp.name : name;
    }
    this.setModelValue(id);
    this.props.viewModel.execute('dimensionChanged', { dimensionId: id })
    this.setState({ currentName: name, currentId: id, bShowList: false })

  }

  handleBodyClick = (e) => {
    if (e.target && cb.dom(e.target).parents('div.ant-popover').length) return;
    if (e.target.parentElement.className == "ant-input-group-addon") return;
    if (e.target.parentElement.className == "ant-popover-open") return;
    if (e.target.tagName == "CANVAS") return;
    if (e.target.parentElement.parentElement.className == "ant-popover-open") return;
    if (e.target.parentElement.className == "ant-input-wrapper ant-input-group") return;
    document.body.removeEventListener('click', this.handleBodyClick);
    this.setState({ bShowList: false });
  }

  render() {
    let bNeedClose = this.state.currentName && this.state.isEnterInput ? true : false;
    let type = this.state.bShowList ? "up" : "down";
    let button = <div>
      {bNeedClose ? <Icon
        onClick={() => this.chooseDimension()}
        type={"close-circle"}
      /> : null}
      <Icon
        onClick={() => this.ShowList()}
        type={type}
      />
    </div>;
    let dimensionList = null;
    dimensionList = this.getDimensionListRender();
    let dimensionPop = (
      <div>
        <div className="Grouping-condition-left">维度导航方案</div>
        <Popover
          overlayStyle={{ width: "236px" }}
          content={dimensionList}
          trigger={"click"}
          visible={this.state.bShowList}>
          <div className="Grouping-condition">
            <div className="Grouping-condition-input"
              onMouseEnter={() => this.onTextMouseEnter(true)}
              onMouseLeave={() => this.onTextMouseEnter(false)}>
              <span className="Grouping-condition-span"
                style={{ cursor: "pointer" }}
                onClick={() => this.ShowList()}
                overlayStyle={{ width: "100px" }}>
                {this.state.currentName}
              </span>
              {button}
            </div>
          </div>
        </Popover>
      </div>
    );
    let dimensionCard = this.getDimensionCardRender();

    return <div className="groupCondition">
      {dimensionPop}
      {dimensionCard}
    </div>;
  }
}

export default DimensionSetting;



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/dimension-setting/DimensionSetting.jsx